// Bâtiments récemment ouverts sur cet appareil (page d'accueil). Alimenté par chaque
// navigation (router.subscribe dans App.js) : on garde l'identifiant du bâtiment, la dernière
// page ouverte pour lui (pour y revenir directement) et la date ; les noms sont relus dans
// /home_overview à l'affichage, donc jamais périmés.

const STORAGE_KEY = 'walter_recent_buildings';
// Dernière réponse de /home_overview : l'accueil s'ouvre aussi hors-ligne, sur la dernière liste connue.
const OVERVIEW_KEY = 'walter_home_overview';
const MAX_ENTRIES = 12;
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

// /client/:client_id/:building_id[/…]  /client/:building_id/(equipments|usages|progress)
// /audit/:id_client/:id_building[/…]   /audit/add_equipment/:id_client/:id_building/…
export function buildingIdFromPath(pathname) {
    const segments = pathname.split('/').filter(Boolean);
    if (segments[0] === 'client') {
        if (UUID.test(segments[2] || '')) return segments[2];
        if (segments.length > 2 && UUID.test(segments[1] || '')) return segments[1];
        return null;
    }
    if (segments[0] === 'audit') {
        if (segments[1] === 'add_equipment') return UUID.test(segments[3] || '') ? segments[3] : null;
        return UUID.test(segments[2] || '') ? segments[2] : null;
    }
    return null;
}

export function getRecentBuildings() {
    try {
        const entries = JSON.parse(localStorage.getItem(STORAGE_KEY));
        return Array.isArray(entries) ? entries : [];
    } catch (error) {
        return [];
    }
}

export function recordVisit(pathname) {
    const buildingId = buildingIdFromPath(pathname);
    if (!buildingId) return;
    const entries = getRecentBuildings().filter((entry) => entry.id !== buildingId);
    try {
        const entry = { id: buildingId, path: pathname, at: Date.now() };
        localStorage.setItem(STORAGE_KEY, JSON.stringify([entry, ...entries].slice(0, MAX_ENTRIES)));
    } catch (error) {
        // Stockage indisponible : l'accueil n'affichera simplement pas d'historique.
    }
}

export function readCachedOverview() {
    try {
        return JSON.parse(localStorage.getItem(OVERVIEW_KEY)) || null;
    } catch (error) {
        return null;
    }
}

export function cacheOverview(overview) {
    try {
        localStorage.setItem(OVERVIEW_KEY, JSON.stringify(overview));
    } catch (error) {
        // Stockage plein ou indisponible : pas de démarrage hors-ligne de l'accueil.
    }
}

// À la déconnexion ou au changement de compte sur l'appareil (cf. AuthContext).
export function clearHomeData() {
    try {
        localStorage.removeItem(STORAGE_KEY);
        localStorage.removeItem(OVERVIEW_KEY);
    } catch (error) {
        // rien à faire
    }
}
